import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const AccountPage = lazy(() =>
  import('./routes/AccountPage').then((m) => ({ default: m.AccountPage })),
);
const ProfilePage = lazy(() =>
  import('./routes/ProfilePage').then((m) => ({ default: m.ProfilePage })),
);
const BillingPage = lazy(() =>
  import('./routes/BillingPage').then((m) => ({ default: m.BillingPage })),
);
const SecurityPage = lazy(() =>
  import('./routes/SecurityPage').then((m) => ({ default: m.SecurityPage })),
);
const IntegrationsPage = lazy(() =>
  import('./routes/IntegrationsPage').then((m) => ({ default: m.IntegrationsPage })),
);
const NotificationsPage = lazy(() =>
  import('./routes/NotificationsPage').then((m) => ({ default: m.NotificationsPage })),
);

/**
 * The signed-in person's own account: the hub, their profile, what their company pays for, their
 * password, the tools they have connected, and how they hear from their agents. Any signed-in person may open them, whatever they have been assigned, so they sit outside
 * the product guard like the team and support screens.
 */
export const accountRoutes: RouteObject[] = [
  { path: ROUTES.account, element: <AccountPage /> },
  { path: ROUTES.profile, element: <ProfilePage /> },
  { path: ROUTES.billing, element: <BillingPage /> },
  { path: ROUTES.accountSecurity, element: <SecurityPage /> },
  { path: ROUTES.integrations, element: <IntegrationsPage /> },
  { path: ROUTES.notifications, element: <NotificationsPage /> },
];
